import controller from './virtualGlycolBuffer.controller';

const template = require('./virtualGlycolBuffer.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
